import { render, staticRenderFns } from "./MemberPremoney.vue?vue&type=template&id=27eae006&scoped=true"
import script from "./MemberPremoney.vue?vue&type=script&lang=js"
export * from "./MemberPremoney.vue?vue&type=script&lang=js"
import style0 from "./MemberPremoney.vue?vue&type=style&index=0&id=27eae006&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27eae006",
  null
  
)

export default component.exports